<div class="loading-wrapper" *ngIf="loading">
  <div class="loading"></div>
</div>
